module.exports = __webpack_public_path__ + "img/a32915fd0caeace3df03e6dc9510913.975974fb.png";